import request from '@/sheep/request';

// 省市区数据
export interface Region {
  id: number;
  name: string;
  parentId: number;
  level: number; // 1-省, 2-市, 3-区
}

const RegionApi = {
  // 获取省份列表
  getProvinceList: () => {
    return request({
      url: '/infra/region/list', 
      method: 'GET',
      params: { level: 1 }
    });
  },
  
  // 获取城市列表（根据省份ID）
  getCityList: (provinceId: number) => {
    return request({
      url: '/infra/region/list',
      method: 'GET',
      params: { parentId: provinceId, level: 2 }
    });
  },
  
  // 获取区县列表（根据城市ID）
  getDistrictList: (cityId: number) => {
    return request({
      url: '/infra/region/list',
      method: 'GET',
      params: { parentId: cityId, level: 3 }
    });
  },
  
  // 获取下级区域列表（通用）
  getChildrenList: (parentId: number) => {
    return request({
      url: '/infra/region/list',
      method: 'GET',
      params: { parentId }
    });
  }
};

export default RegionApi;
